import OffDatesService from '@/services/offDates-service'

const state = {
  items: null
}

const mutations = {
  SET (state, payload) {
    state.items = payload
  }
}

const actions = {
  fetch: async ({commit, state}, payload) => {
    payload = payload || {force: false}

    if (state.items && !payload.force)
      return state.items
    
    return OffDatesService.list().then(items => {
      commit('SET', items)
      return items
    })
  },
  sync: ({ commit, state, dispatch}, data) => {
    return OffDatesService.modify(data).then(x => {
      dispatch('fetch', {force: true})
    })
  },
  calcOffCount: ({ state }, startend) => {
    return state.items.filter(x => new Date(x.date).setHours( 0,0,0,0 ) >= new Date(startend.start).setHours( 0,0,0,0 ) && new Date(x.date).setHours( 0,0,0,0 ) <= new Date(startend.end).setHours( 0,0,0,0 )).length
  }
}

const getters = {
  offDates: (state, getters) => {
    return state.items
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
